export const MOCK_AUTH_RESPONSE = {
  access_token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJidXNpbmVzc191c2VyXzAwMSIsInJvbGUiOiJidXNpbmVzcyIsImV4cCI6MTc2ODIzMzEzN30.GTT_5TEZap7ELIxoe32hQr9KFtJ0AinTT_sOlfFeXV0",
  token_type: "bearer"
};

export const MOCK_COHORT_RESPONSE = {
  message: "Mock preview generated successfully (CORS fallback)."
};

export const MOCK_COHORTS = [
  {
    segment_id: "7d1ca6ce292ea1b9",
    cohort_name: "Diabetes Diagnosed in Last Year Excluding Cancer",
    count: 8,
    status: "PREVIEWED",
    created_at: "2026-01-12T08:22:33.406703Z"
  },
  {
    segment_id: "8e2ba9fd312aa9c1",
    cohort_name: "Hypertension Patients Above 50",
    count: 12,
    status: "PREVIEWED",
    created_at: "2026-01-11T10:15:00.000Z"
  },
  {
    segment_id: "9f1cc7ae109bc821",
    cohort_name: "Chronic Kidney Disease Patients",
    count: 5,
    status: "PREVIEWED",
    created_at: "2026-01-10T14:30:00.000Z"
  }
];


// List shown in sidebar (ChatGPT "Your chats" style)
export const MOCK_COHORT_PREVIEWS = [
    {
      "trace_id": "04d50849535b4b59a99ef547bb4010b1",
      "segment_id": "2f054ae366316b76",
      "cohort_name": "Type 3 Diabetes Cohort",
      "preview_count": 0,
      "status": "PREVIEWED",
      "created_at": "2026-01-14T10:51:14Z"
    },
    {
      "trace_id": "88277d530f574dc48c8360d14ee7daff",
      "segment_id": "a4cc127a11c71ab6",
      "cohort_name": "Type 1 Diabetes Patients",
      "preview_count": 0,
      "status": "PREVIEWED",
      "created_at": "2026-01-14T10:47:18Z"
    },
    {
      "trace_id": "2c68ff5f19204c9f9b769790499ab93d",
      "segment_id": "c8995c9c4d93614c",
      "cohort_name": "Viral Fever Patients",
      "preview_count": 0,
      "status": "PREVIEWED",
      "created_at": "2026-01-14T10:46:34Z"
    },
    {
      "trace_id": "c934a21773744acb8d7f91def73e7084",
      "segment_id": "e242a0cdd5dc174a",
      "cohort_name": "Fever with Cold",
      "preview_count": 0,
      "status": "PREVIEWED",
      "created_at": "2026-01-14T10:45:37Z"
    },
    {
      "trace_id": "04d50849535b4b59a99ef547bb4010b1",
      "segment_id": "d9ed8ccaffc11aa2",
      "cohort_name": "Type 1 Diabetes in the Last Year",
      "preview_count": 0,
      "status": "PREVIEWED",
      "created_at": "2026-01-14T08:31:57Z"
    },
    {
      "trace_id": "fe6e5d25c9c841cabcd172115eff0ab4",
      "segment_id": "3d0151b48101d9d6",
      "cohort_name": "Cancer Diagnosis in the Last Year",
      "preview_count": 0,
      "status": "PREVIEWED",
      "created_at": "2026-01-14T08:31:10Z"
    },
    {
      "trace_id": "04d50849535b4b59a99ef547bb4010b1",
      "segment_id": "bda4091b03b542bc",
      "cohort_name": "Type 2 Diabetes in the Last Year",
      "preview_count": 3,
      "status": "PREVIEWED",
      "created_at": "2026-01-14T08:30:32Z"
    }
  ];

// Details shown when clicking a cohort
export const MOCK_COHORT_DETAILS = [
  {
    segment_id: "7d1ca6ce292ea1b9",
    status: "PREVIEWED",
    created_at: "2026-01-12T08:22:33.406703Z"
  },
  {
    segment_id: "8e2ba9fd312aa9c1",
    status: "PREVIEWED",
    created_at: "2026-01-11T10:15:00.000Z"
  }
];

export const MOCK_MATERIALIZE_RESPONSE = {
  run_id: "7d1ca6ce292ea1b9",
  row_count: 3,
  status: "COMPLETED"
};
export const MOCK_RUN_RESPONSE = {
  run_id: "7d1ca6ce292ea1b9",
  status: "COMPLETED",
  row_count: 1820,
  started_at: "2026-01-12T12:19:24.917307Z",
  finished_at: "2026-01-12T12:19:24.917316Z"
};
export const MOCK_EXPORT_CSV = `member_id,full_name,email,phone
100001,John Carter,john.carter@example.com,+1-415-555-0101
100014,Maria Gonzalez,maria.gonzalez@example.com,+1-415-555-0102
100032,David Lee,david.lee@example.com,+1-415-555-0103
100057,Anita Patel,anita.patel@example.com,+1-415-555-0104
100089,Robert Johnson,robert.johnson@example.com,+1-415-555-0105
100104,Sarah Kim,sarah.kim@example.com,+1-415-555-0106
100145,Michael Brown,michael.brown@example.com,+1-415-555-0107
100188,Emily Davis,emily.davis@example.com,+1-415-555-0108
100233,Ahmed Khan,ahmed.khan@example.com,+1-415-555-0109
100301,Laura Wilson,laura.wilson@example.com,+1-415-555-0110
`;
